export default [{
  name: 'shifts',
  path: '/shifts',
  redirect: { name: 'incidental shifts' },
  component: () => import('@web/pages/shifts/Index.vue'),
  meta: { title: 'Opdrachten' },
  children: [
    {
      name: 'incidental shifts',
      path: 'incidental',
      component: () => import('@web/pages/shifts/Index.vue'),
      meta: { title: 'Opdrachten' },
    },
    {
      name: 'periodical shifts',
      path: 'periodical',
      component: () => import('@web/pages/shifts/Index.vue'),
      meta: { title: 'Opdrachten' },
    },
  ],
}];
